import {Component} from '@angular/core';
import {BlockElementArticle} from 'app/entities/blockElements/blockElementAritlce';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-article-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementArticleComponent extends BlockElementAbstractComponent<BlockElementArticle> {

}
